// accordion.js
document.addEventListener("DOMContentLoaded", function () {
  try {
    var accordions = document.querySelectorAll(".accordion-button");

    // If no accordions found, exit gracefully
    if (accordions.length === 0) {
      return;
    }

    // Function to calculate and store accordion heights
    function calculateAccordionHeights() {
      accordions.forEach(function (accordion, index) {
        try {
          var dataIndex = accordion.getAttribute("data-index");
          var targetCollapse = document.getElementById("collapse-" + dataIndex);

          if (targetCollapse) {
            var accordionBody = targetCollapse.querySelector(".accordion-body");
            if (accordionBody) {
              // Method 1: Get height with proper content measurement
              // First, ensure the accordion is fully visible to get accurate height
              targetCollapse.style.maxHeight = "none";
              targetCollapse.style.visibility = "visible";
              targetCollapse.style.position = "static";
              targetCollapse.style.height = "auto";

              // Force a reflow to ensure all content is rendered
              targetCollapse.offsetHeight;

              // Get the full content height including margins and padding
              var naturalHeight = accordionBody.scrollHeight;

              // Add some buffer to ensure nothing is cut off
              var bufferHeight = 20; // 20px buffer
              var finalHeight = naturalHeight + bufferHeight;

              // Reset styles back to collapsed state
              targetCollapse.style.maxHeight = "";
              targetCollapse.style.visibility = "";
              targetCollapse.style.position = "";
              targetCollapse.style.height = "";

              // Store the calculated height
              targetCollapse.setAttribute("data-height", finalHeight);
            }
          }
        } catch (error) {
          // Silent error handling
        }
      });
    }

    // Wait longer for all content to render, then calculate heights
    setTimeout(function () {
      try {
        calculateAccordionHeights();
      } catch (error) {
        // Silent error handling
      }
    }, 200);

    // Recalculate heights on window resize
    window.addEventListener("resize", function () {
      try {
        // Debounce the resize event
        clearTimeout(window.resizeTimeout);
        window.resizeTimeout = setTimeout(calculateAccordionHeights, 250);
      } catch (error) {
        // Silent error handling
      }
    });

    accordions.forEach(function (accordion, index) {
      accordion.addEventListener("click", function (e) {
        try {
          // Prevent default button behavior but allow normal accordion functionality
          e.preventDefault();

          var dataIndex = this.getAttribute("data-index");
          var targetCollapse = document.getElementById("collapse-" + dataIndex);

          // Check if targetCollapse exists before proceeding
          if (!targetCollapse) {
            return;
          }

          // Get current expanded state
          var isExpanded = this.getAttribute("aria-expanded") === "true";

          // Toggle the expanded state
          var newExpandedState = !isExpanded;

          // Update the button attributes
          this.setAttribute("aria-expanded", newExpandedState.toString());

          // Update the collapse element attributes
          targetCollapse.setAttribute("aria-hidden", (!newExpandedState).toString());

          // Get the stored height and toggle the accordion
          var storedHeight = targetCollapse.getAttribute("data-height");

          if (storedHeight && storedHeight !== "0") {
            if (newExpandedState) {
              // Opening the accordion
              targetCollapse.style.setProperty("--accordion-height", storedHeight + "px");
              targetCollapse.classList.add("show");
            } else {
              // Closing the accordion
              targetCollapse.classList.remove("show");
            }
          } else {
            // Fallback to class toggle if no height stored
            if (newExpandedState) {
              targetCollapse.classList.add("show");
            } else {
              targetCollapse.classList.remove("show");
            }
          }

          // Dispatch event to notify other components (like tab animations) that accordion changed
          var accordionEvent = new CustomEvent("accordionChanged", {
            detail: {
              accordionIndex: dataIndex,
              isExpanded: newExpandedState,
              accordionElement: this,
              collapseElement: targetCollapse,
            },
          });
          document.dispatchEvent(accordionEvent);
        } catch (error) {
          // Silent error handling
        }
      });
    });
  } catch (error) {
    // Silent error handling
  }
});
